import React, { FunctionComponent } from 'react';
import { Box } from '@material-ui/core';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import SimpleBrandSectionDetails from '../../simpleBrands/customiseSectionDetails/CustomiseSectionDetails';
import ISection from '../../../../../model/ISection';
import FeatureSectionDetails from './FeatureSectionDetails';

export interface IFeatureSectionDetailsContainerProps {
  section: ISection;
  loading: boolean;
}

const FeatureSectionDetailsContainer: FunctionComponent<IFeatureSectionDetailsContainerProps> = ({
  section,
  loading,
}) => {
  const {
    platformConfig: { isComplexModel },
  } = usePlatformConfig();

  return (
    <Box width={'100%'}>
      {isComplexModel ? (
        <FeatureSectionDetails section={section} loading={loading} />
      ) : (
        <SimpleBrandSectionDetails section={section} loading={loading} />
      )}
    </Box>
  );
};

export default FeatureSectionDetailsContainer;
